// Maps an Actuals vs Budget variance figure to a favourable/adverse text-colour
// class for the report tables.
//
// The variance value itself is always `budget − actuals` (unchanged) — this
// helper only decides the *colour*. Whether a given sign is GOOD or BAD depends
// on the row:
//   • Expenditure rows   → positive variance (underspend) is favourable → green;
//                           negative (overspend) is adverse → red.
//   • Revenue / Net rows  → inverted: negative variance (actuals exceed budget =
//                           more revenue) is favourable → green; positive is red.
//
// `favourableWhenNegative` selects that inversion (true for revenue / net rows).
// A zero — or missing (comparison dash) — variance is neutral and gets no colour.
//
// Dark rows (blue total / charcoal net / dark-blue footer backgrounds) carry
// white text, so pass `dark = true` for the lighter palette tints that stay
// legible against the fill; light rows use the full-strength tokens.

export const varianceColourClass = (variance, favourableWhenNegative = false, dark = false) => {
    const value = Number(variance);

    if (!isFinite(value) || value === 0) {
        return '';
    }

    const isFavourable = favourableWhenNegative ? value < 0 : value > 0;

    if (isFavourable) {
        return dark ? 'tw-text-green-50' : 'tw-text-green';
    }

    return dark ? 'tw-text-red-50' : 'tw-text-red';
};
